import { CurrencyState } from '@/features/shared/currency-store';

export const currencySelectors = {
  currency: (state: CurrencyState) => state.currentCurrency,
  setCurrency: (state: CurrencyState) => state.setCurrentCurrency,
};
